import {ProductList, ProductListFilterItemType, ProductListFilterItemValueType} from "@connox/typescript-library";
import {ProductListAction} from "../actions";

// this effect will update the max and min values for range filters after every change of filters state
// its done that way as work around because its very costly to do this in the backend (Pflaster Lösung)
// https://github.com/Connox/templates-connox/pull/2080/files#diff-33140a7d1555ae495bb40fe443c07ced6cd5f425e7827a7b1472ac4129ef7a59
export const getNewRangeValues = async (
  instance: ProductList,
  presentFilters: {[p: string]: ProductListFilterItemValueType},
  dispatch: React.Dispatch<ProductListAction>,
) => {
  const availableRangeFiltersFields = Array.from(instance.filter.filterItems).reduce(
    (acc: string[], [key, keyValue]) => {
      if (
        keyValue.type === ProductListFilterItemType.range &&
        presentFilters[key] !== undefined &&
        key !== "percentageDiscount"
      ) {
        acc.push(key);
      }

      return acc;
    },
    [],
  );

  if (availableRangeFiltersFields.length < 2) {
    return;
  }

  const tempLimit = instance.limit;
  const tempOffset = instance.offset;
  const tempRangeFilters: {[k: string]: ProductListFilterItemValueType} = {};

  const allPromises = availableRangeFiltersFields.map((key) => {
    const filtersNoKey = Object.assign({}, presentFilters);
    delete filtersNoKey[key];
    const deletedRangeFilter = instance.filter.filterItems.get(key);
    if (deletedRangeFilter) {
      tempRangeFilters[key] = deletedRangeFilter.value;
    }

    instance.filter.applyFilterValue(filtersNoKey);

    return instance
      .send()
      .then((data) => {
        const filterToDispatch = data.availableFilters.find((filter) => filter.field === key);
        if (filterToDispatch) {
          dispatch({
            type: "SET_RANGE_FILTERS_VALUES",
            payload: {
              field: filterToDispatch.field,
              value: {
                min: Math.floor(Number(filterToDispatch.minValue ?? 0)),
                max: Math.ceil(Number(filterToDispatch.maxValue ?? 0)),
              },
            },
          });
        }
      })
      .then(() => key)
      .catch(() => key);
  });

  await Promise.all<string>(allPromises).then(() => {
    instance.limit = tempLimit;
    instance.offset = tempOffset;
    instance.filter.applyFilterValue(tempRangeFilters);
  });
};
